import { SVGProps } from 'react'

export const InspectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5 10H5.5M7.5 14H5.5M13.5 6H5.5M17.5 9.5V5.8C17.5 4.11984 17.5 3.27976 17.173 2.63803C16.8854 2.07354 16.4265 1.6146 15.862 1.32698C15.2202 1 14.3802 1 12.7 1H6.3C4.61984 1 3.77976 1 3.13803 1.32698C2.57354 1.6146 2.1146 2.07354 1.82698 2.63803C1.5 3.27976 1.5 4.11984 1.5 5.8V16.2C1.5 17.8802 1.5 18.7202 1.82698 19.362C2.1146 19.9265 2.57354 20.3854 3.13803 20.673C3.77976 21 4.61984 21 6.3 21H9M19.5 21L18 19.5M19 17C19 18.933 17.433 20.5 15.5 20.5C13.567 20.5 12 18.933 12 17C12 15.067 13.567 13.5 15.5 13.5C17.433 13.5 19 15.067 19 17Z"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
